module.exports = function (t) {
  var e = {};
  function n(r) {
    if (e[r]) return e[r].exports;
    var o = e[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }
  return n.m = t, n.c = e, n.d = function (t, e, r) {
    n.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, n.t = function (t, e) {
    if (1 & e && (t = n(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var o in t) n.d(r, o, function (e) {
      return t[e];
    }.bind(null, o));
    return r;
  }, n.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return n.d(e, "a", e), e;
  }, n.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, n.p = "", n(n.s = 18);
}([function (t, e) {
  t.exports = require("react");
}, function (t, e) {
  t.exports = require("prop-types");
}, function (t, e, n) {
  var r = n(14);
  "string" == typeof r && (r = [[t.i, r, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  n(4)(r, o);
  r.locals && (t.exports = r.locals);
}, function (t, e) {
  t.exports = function (t) {
    var e = [];
    return e.toString = function () {
      return this.map(function (e) {
        var n = function (t, e) {
          var n = t[1] || "",
            r = t[3];
          if (!r) return n;
          if (e && "function" == typeof btoa) {
            var o = (a = r, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(a)))) + " */"),
              i = r.sources.map(function (t) {
                return "/*# sourceURL=" + r.sourceRoot + t + " */";
              });
            return [n].concat(i).concat([o]).join("\n");
          }
          var a;
          return [n].join("\n");
        }(e, t);
        return e[2] ? "@media " + e[2] + "{" + n + "}" : n;
      }).join("");
    }, e.i = function (t, n) {
      "string" == typeof t && (t = [[null, t, ""]]);
      for (var r = {}, o = 0; o < this.length; o++) {
        var i = this[o][0];
        "number" == typeof i && (r[i] = !0);
      }
      for (o = 0; o < t.length; o++) {
        var a = t[o];
        "number" == typeof a[0] && r[a[0]] || (n && !a[2] ? a[2] = n : n && (a[2] = "(" + a[2] + ") and (" + n + ")"), e.push(a));
      }
    }, e;
  };
}, function (t, e, n) {
  var r,
    o,
    i = {},
    a = (r = function () {
      return window && document && document.all && !window.atob;
    }, function () {
      return void 0 === o && (o = r.apply(this, arguments)), o;
    }),
    c = function (t, e) {
      return e ? e.querySelector(t) : document.querySelector(t);
    },
    s = function (t) {
      var e = {};
      return function (t, n) {
        if ("function" == typeof t) return t();
        if (void 0 === e[t]) {
          var r = c.call(this, t, n);
          if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
            r = r.contentDocument.head;
          } catch (t) {
            r = null;
          }
          e[t] = r;
        }
        return e[t];
      };
    }(),
    u = null,
    l = 0,
    f = [],
    p = n(13);
  function b(t, e) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n],
        o = i[r.id];
      if (o) {
        o.refs++;
        for (var a = 0; a < o.parts.length; a++) o.parts[a](r.parts[a]);
        for (; a < r.parts.length; a++) o.parts.push(w(r.parts[a], e));
      } else {
        var c = [];
        for (a = 0; a < r.parts.length; a++) c.push(w(r.parts[a], e));
        i[r.id] = {
          id: r.id,
          refs: 1,
          parts: c
        };
      }
    }
  }
  function m(t, e) {
    for (var n = [], r = {}, o = 0; o < t.length; o++) {
      var i = t[o],
        a = e.base ? i[0] + e.base : i[0],
        c = {
          css: i[1],
          media: i[2],
          sourceMap: i[3]
        };
      r[a] ? r[a].parts.push(c) : n.push(r[a] = {
        id: a,
        parts: [c]
      });
    }
    return n;
  }
  function y(t, e) {
    var n = s(t.insertInto);
    if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
    var r = f[f.length - 1];
    if ("top" === t.insertAt) r ? r.nextSibling ? n.insertBefore(e, r.nextSibling) : n.appendChild(e) : n.insertBefore(e, n.firstChild), f.push(e);else if ("bottom" === t.insertAt) n.appendChild(e);else {
      if ("object" != typeof t.insertAt || !t.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
      var o = s(t.insertAt.before, n);
      n.insertBefore(e, o);
    }
  }
  function d(t) {
    if (null === t.parentNode) return !1;
    t.parentNode.removeChild(t);
    var e = f.indexOf(t);
    e >= 0 && f.splice(e, 1);
  }
  function h(t) {
    var e = document.createElement("style");
    if (void 0 === t.attrs.type && (t.attrs.type = "text/css"), void 0 === t.attrs.nonce) {
      var r = function () {
        0;
        return n.nc;
      }();
      r && (t.attrs.nonce = r);
    }
    return g(e, t.attrs), y(t, e), e;
  }
  function g(t, e) {
    Object.keys(e).forEach(function (n) {
      t.setAttribute(n, e[n]);
    });
  }
  function w(t, e) {
    var n, r, o, i;
    if (e.transform && t.css) {
      if (!(i = "function" == typeof e.transform ? e.transform(t.css) : e.transform.default(t.css))) return function () {};
      t.css = i;
    }
    if (e.singleton) {
      var a = l++;
      n = u || (u = h(e)), r = O.bind(null, n, a, !1), o = O.bind(null, n, a, !0);
    } else t.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (n = function (t) {
      var e = document.createElement("link");
      return void 0 === t.attrs.type && (t.attrs.type = "text/css"), t.attrs.rel = "stylesheet", g(e, t.attrs), y(t, e), e;
    }(e), r = z.bind(null, n, e), o = function () {
      d(n), n.href && URL.revokeObjectURL(n.href);
    }) : (n = h(e), r = k.bind(null, n), o = function () {
      d(n);
    });
    return r(t), function (e) {
      if (e) {
        if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap) return;
        r(t = e);
      } else o();
    };
  }
  t.exports = function (t, e) {
    if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
    (e = e || {}).attrs = "object" == typeof e.attrs ? e.attrs : {}, e.singleton || "boolean" == typeof e.singleton || (e.singleton = a()), e.insertInto || (e.insertInto = "head"), e.insertAt || (e.insertAt = "bottom");
    var n = m(t, e);
    return b(n, e), function (t) {
      for (var r = [], o = 0; o < n.length; o++) {
        var a = n[o];
        (c = i[a.id]).refs--, r.push(c);
      }
      t && b(m(t, e), e);
      for (o = 0; o < r.length; o++) {
        var c;
        if (0 === (c = r[o]).refs) {
          for (var s = 0; s < c.parts.length; s++) c.parts[s]();
          delete i[c.id];
        }
      }
    };
  };
  var v,
    _ = (v = [], function (t, e) {
      return v[t] = e, v.filter(Boolean).join("\n");
    });
  function O(t, e, n, r) {
    var o = n ? "" : r.css;
    if (t.styleSheet) t.styleSheet.cssText = _(e, o);else {
      var i = document.createTextNode(o),
        a = t.childNodes;
      a[e] && t.removeChild(a[e]), a.length ? t.insertBefore(i, a[e]) : t.appendChild(i);
    }
  }
  function k(t, e) {
    var n = e.css,
      r = e.media;
    if (r && t.setAttribute("media", r), t.styleSheet) t.styleSheet.cssText = n;else {
      for (; t.firstChild;) t.removeChild(t.firstChild);
      t.appendChild(document.createTextNode(n));
    }
  }
  function z(t, e, n) {
    var r = n.css,
      o = n.sourceMap,
      i = void 0 === e.convertToAbsoluteUrls && o;
    (e.convertToAbsoluteUrls || i) && (r = p(r)), o && (r += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
    var a = new Blob([r], {
        type: "text/css"
      }),
      c = t.href;
    t.href = URL.createObjectURL(a), c && URL.revokeObjectURL(c);
  }
}, function (t, e, n) {
  var r = n(16);
  "string" == typeof r && (r = [[t.i, r, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  n(4)(r, o);
  r.locals && (t.exports = r.locals);
}, function (t, e) {
  t.exports = require("react-dom");
}, function (t, e) {
  t.exports = require("classnames");
}, function (t, e) {
  t.exports = require("lodash.memoize");
}, function (t, e, n) {
  var r = n(15);
  "string" == typeof r && (r = [[t.i, r, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  n(4)(r, o);
  r.locals && (t.exports = r.locals);
}, function (t, e, n) {
  var r = n(12);
  "string" == typeof r && (r = [[t.i, r, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  n(4)(r, o);
  r.locals && (t.exports = r.locals);
}, function (t, e, n) {
  var r = n(17);
  "string" == typeof r && (r = [[t.i, r, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  n(4)(r, o);
  r.locals && (t.exports = r.locals);
}, function (t, e, n) {
  (e = t.exports = n(3)(!1)).push([t.i, ".wrapperLayer__z_PKn {\n  position: fixed;\n  margin: 0;\n  padding: 0;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 999;\n}\n", ""]), e.locals = {
    wrapperLayer: "wrapperLayer__z_PKn"
  };
}, function (t, e) {
  t.exports = function (t) {
    var e = "undefined" != typeof window && window.location;
    if (!e) throw new Error("fixUrls requires window.location");
    if (!t || "string" != typeof t) return t;
    var n = e.protocol + "//" + e.host,
      r = n + e.pathname.replace(/\/[^\/]*$/, "/");
    return t.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (t, e) {
      var o,
        i = e.trim().replace(/^"(.*)"$/, function (t, e) {
          return e;
        }).replace(/^'(.*)'$/, function (t, e) {
          return e;
        });
      return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(i) ? t : (o = 0 === i.indexOf("//") ? i : 0 === i.indexOf("/") ? n + i : r + i.replace(/^\.\//, ""), "url(" + JSON.stringify(o) + ")");
    });
  };
}, function (t, e, n) {
  (e = t.exports = n(3)(!1)).push([t.i, "/* 与 anim.js 同步 */\n.baseButton__2AV5J {\n  z-index: 1000;\n  box-sizing: border-box;\n  cursor: pointer;\n}\n.baseButton__2AV5J > svg {\n  display: block;\n  width: 2rem;\n  height: 2rem;\n}\n.controls__NTVNu {\n  box-sizing: border-box;\n  position: absolute;\n  top: 0.6rem;\n  right: 0.6rem;\n  opacity: 0;\n  display: -webkit-box;\n  display: flex;\n  z-index: 1000;\n  border-radius: 5rem;\n  -webkit-transform: translateX(100%);\n          transform: translateX(100%);\n  -webkit-transition: opacity 350ms, -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms, -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms;\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms, -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n}\n.controls__NTVNu.show__2Pu4e {\n  opacity: 0.8;\n  -webkit-transform: translateX(0);\n          transform: translateX(0);\n}\n.controls__NTVNu .pinButton__pLhHH {\n  z-index: 1000;\n  box-sizing: border-box;\n  cursor: pointer;\n  margin: 0.4em 0;\n  width: 2rem;\n  height: 2rem;\n  -webkit-transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n}\n.controls__NTVNu .pinButton__pLhHH > svg {\n  display: block;\n  width: 2rem;\n  height: 2rem;\n}\n.controls__NTVNu .pinButton__pLhHH:hover {\n  opacity: 0.8 !important;\n  -webkit-transform: scale(1.1) !important;\n          transform: scale(1.1) !important;\n}\n.controls__NTVNu .pinButton__pLhHH:active {\n  opacity: 1 !important;\n  -webkit-transform: scale(1) !important;\n          transform: scale(1) !important;\n}\n.controls__NTVNu .pinButton__pLhHH:first-of-type {\n  margin-left: 0.4rem;\n}\n.controls__NTVNu .pinButton__pLhHH:last-of-type {\n  margin-right: 0.4rem;\n}\n.controls__NTVNu .rotate__18SVA {\n  z-index: 1000;\n  box-sizing: border-box;\n  cursor: pointer;\n  margin: 0.4em 0;\n  width: 2rem;\n  height: 2rem;\n  -webkit-transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n}\n.controls__NTVNu .rotate__18SVA > svg {\n  display: block;\n  width: 2rem;\n  height: 2rem;\n}\n.controls__NTVNu .rotate__18SVA:hover {\n  opacity: 0.8 !important;\n  -webkit-transform: scale(1.1) !important;\n          transform: scale(1.1) !important;\n}\n.controls__NTVNu .rotate__18SVA:active {\n  opacity: 1 !important;\n  -webkit-transform: scale(1) !important;\n          transform: scale(1) !important;\n}\n.controls__NTVNu .rotate__18SVA:first-of-type {\n  margin-left: 0.4rem;\n}\n.controls__NTVNu .rotate__18SVA:last-of-type {\n  margin-right: 0.4rem;\n}\n.controls__NTVNu .rotate__18SVA svg {\n  width: 1.75rem;\n  -webkit-transition: -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n}\n.controls__NTVNu .rotateLeft__1y4kO {\n  z-index: 1000;\n  box-sizing: border-box;\n  cursor: pointer;\n  margin: 0.4em 0;\n  width: 2rem;\n  height: 2rem;\n  -webkit-transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n}\n.controls__NTVNu .rotateLeft__1y4kO > svg {\n  display: block;\n  width: 2rem;\n  height: 2rem;\n}\n.controls__NTVNu .rotateLeft__1y4kO:hover {\n  opacity: 0.8 !important;\n  -webkit-transform: scale(1.1) !important;\n          transform: scale(1.1) !important;\n}\n.controls__NTVNu .rotateLeft__1y4kO:active {\n  opacity: 1 !important;\n  -webkit-transform: scale(1) !important;\n          transform: scale(1) !important;\n}\n.controls__NTVNu .rotateLeft__1y4kO:first-of-type {\n  margin-left: 0.4rem;\n}\n.controls__NTVNu .rotateLeft__1y4kO:last-of-type {\n  margin-right: 0.4rem;\n}\n.controls__NTVNu .rotateLeft__1y4kO svg {\n  width: 1.75rem;\n  -webkit-transition: -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n}\n.controls__NTVNu .rotateLeft__1y4kO:hover svg {\n  -webkit-transform: rotate(-30deg);\n          transform: rotate(-30deg);\n}\n.controls__NTVNu .rotateRight__1GeTD {\n  z-index: 1000;\n  box-sizing: border-box;\n  cursor: pointer;\n  margin: 0.4em 0;\n  width: 2rem;\n  height: 2rem;\n  -webkit-transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n}\n.controls__NTVNu .rotateRight__1GeTD > svg {\n  display: block;\n  width: 2rem;\n  height: 2rem;\n}\n.controls__NTVNu .rotateRight__1GeTD:hover {\n  opacity: 0.8 !important;\n  -webkit-transform: scale(1.1) !important;\n          transform: scale(1.1) !important;\n}\n.controls__NTVNu .rotateRight__1GeTD:active {\n  opacity: 1 !important;\n  -webkit-transform: scale(1) !important;\n          transform: scale(1) !important;\n}\n.controls__NTVNu .rotateRight__1GeTD:first-of-type {\n  margin-left: 0.4rem;\n}\n.controls__NTVNu .rotateRight__1GeTD:last-of-type {\n  margin-right: 0.4rem;\n}\n.controls__NTVNu .rotateRight__1GeTD svg {\n  width: 1.75rem;\n  -webkit-transition: -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n}\n.controls__NTVNu .rotateRight__1GeTD:hover svg {\n  -webkit-transform: rotate(30deg);\n          transform: rotate(30deg);\n}\n.controls__NTVNu .download__TnaVI {\n  z-index: 1000;\n  box-sizing: border-box;\n  cursor: pointer;\n  margin: 0.4em 0;\n  width: 2rem;\n  height: 2rem;\n  -webkit-transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n}\n.controls__NTVNu .download__TnaVI > svg {\n  display: block;\n  width: 2rem;\n  height: 2rem;\n}\n.controls__NTVNu .download__TnaVI:hover {\n  opacity: 0.8 !important;\n  -webkit-transform: scale(1.1) !important;\n          transform: scale(1.1) !important;\n}\n.controls__NTVNu .download__TnaVI:active {\n  opacity: 1 !important;\n  -webkit-transform: scale(1) !important;\n          transform: scale(1) !important;\n}\n.controls__NTVNu .download__TnaVI:first-of-type {\n  margin-left: 0.4rem;\n}\n.controls__NTVNu .download__TnaVI:last-of-type {\n  margin-right: 0.4rem;\n}\n.controls__NTVNu .download__TnaVI svg {\n  margin-top: -0.06rem;\n  width: 1.75rem;\n}\n.controls__NTVNu .zoom__1W2_u {\n  z-index: 1000;\n  box-sizing: border-box;\n  cursor: pointer;\n  margin: 0.4em 0;\n  width: 2rem;\n  height: 2rem;\n  -webkit-transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n}\n.controls__NTVNu .zoom__1W2_u > svg {\n  display: block;\n  width: 2rem;\n  height: 2rem;\n}\n.controls__NTVNu .zoom__1W2_u:hover {\n  opacity: 0.8 !important;\n  -webkit-transform: scale(1.1) !important;\n          transform: scale(1.1) !important;\n}\n.controls__NTVNu .zoom__1W2_u:active {\n  opacity: 1 !important;\n  -webkit-transform: scale(1) !important;\n          transform: scale(1) !important;\n}\n.controls__NTVNu .zoom__1W2_u:first-of-type {\n  margin-left: 0.4rem;\n}\n.controls__NTVNu .zoom__1W2_u:last-of-type {\n  margin-right: 0.4rem;\n}\n.controls__NTVNu .close__h79Tx {\n  z-index: 1000;\n  box-sizing: border-box;\n  cursor: pointer;\n  margin: 0.4em 0;\n  width: 2rem;\n  height: 2rem;\n  -webkit-transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n}\n.controls__NTVNu .close__h79Tx > svg {\n  display: block;\n  width: 2rem;\n  height: 2rem;\n}\n.controls__NTVNu .close__h79Tx:hover {\n  opacity: 0.8 !important;\n  -webkit-transform: scale(1.1) !important;\n          transform: scale(1.1) !important;\n}\n.controls__NTVNu .close__h79Tx:active {\n  opacity: 1 !important;\n  -webkit-transform: scale(1) !important;\n          transform: scale(1) !important;\n}\n.controls__NTVNu .close__h79Tx:first-of-type {\n  margin-left: 0.4rem;\n}\n.controls__NTVNu .close__h79Tx:last-of-type {\n  margin-right: 0.4rem;\n}\n.sideButton__25vo1 {\n  z-index: 1000;\n  box-sizing: border-box;\n  cursor: pointer;\n  opacity: 0;\n  position: absolute;\n  top: 50%;\n  padding: 0.4rem;\n  -webkit-transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n}\n.sideButton__25vo1 > svg {\n  display: block;\n  width: 2rem;\n  height: 2rem;\n}\n.sideButton__25vo1:hover {\n  opacity: 0.8 !important;\n  -webkit-transform: translateX(0) translateY(-50%) !important;\n          transform: translateX(0) translateY(-50%) !important;\n}\n.sideButton__25vo1:active {\n  opacity: 1 !important;\n}\n.sideButton__25vo1.show__2Pu4e {\n  opacity: 0.8;\n}\n.flipLeft__fhip_ {\n  z-index: 1000;\n  box-sizing: border-box;\n  cursor: pointer;\n  opacity: 0;\n  position: absolute;\n  top: 50%;\n  padding: 0.4rem;\n  -webkit-transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  left: 0;\n  padding-left: 0.6rem;\n  border-radius: 0 0.5em 0.5em 0;\n  -webkit-transform: translateX(-100%) translateY(-50%);\n          transform: translateX(-100%) translateY(-50%);\n}\n.flipLeft__fhip_ > svg {\n  display: block;\n  width: 2rem;\n  height: 2rem;\n}\n.flipLeft__fhip_:hover {\n  opacity: 0.8 !important;\n  -webkit-transform: translateX(0) translateY(-50%) !important;\n          transform: translateX(0) translateY(-50%) !important;\n}\n.flipLeft__fhip_:active {\n  opacity: 1 !important;\n}\n.flipLeft__fhip_.show__2Pu4e {\n  opacity: 0.8;\n}\n.flipLeft__fhip_:active {\n  -webkit-transform: translate(-0.2em) translateY(-50%) !important;\n          transform: translate(-0.2em) translateY(-50%) !important;\n}\n.flipLeft__fhip_.show__2Pu4e {\n  opacity: 0.8;\n  -webkit-transform: translate(-0.2em) translateY(-50%);\n          transform: translate(-0.2em) translateY(-50%);\n}\n.flipRight__2T92B {\n  z-index: 1000;\n  box-sizing: border-box;\n  cursor: pointer;\n  opacity: 0;\n  position: absolute;\n  top: 50%;\n  padding: 0.4rem;\n  -webkit-transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  right: 0;\n  padding-right: 0.6rem;\n  border-radius: 0.5rem 0 0 0.5rem;\n  -webkit-transform: translateX(100%) translateY(-50%);\n          transform: translateX(100%) translateY(-50%);\n}\n.flipRight__2T92B > svg {\n  display: block;\n  width: 2rem;\n  height: 2rem;\n}\n.flipRight__2T92B:hover {\n  opacity: 0.8 !important;\n  -webkit-transform: translateX(0) translateY(-50%) !important;\n          transform: translateX(0) translateY(-50%) !important;\n}\n.flipRight__2T92B:active {\n  opacity: 1 !important;\n}\n.flipRight__2T92B.show__2Pu4e {\n  opacity: 0.8;\n}\n.flipRight__2T92B:active {\n  -webkit-transform: translate(0.2em) translateY(-50%) !important;\n          transform: translate(0.2em) translateY(-50%) !important;\n}\n.flipRight__2T92B.show__2Pu4e {\n  opacity: 0.8;\n  -webkit-transform: translate(0.2em) translateY(-50%);\n          transform: translate(0.2em) translateY(-50%);\n}\n.pages__2jlej {\n  box-sizing: border-box;\n  display: -webkit-box;\n  display: flex;\n  position: absolute;\n  left: 50%;\n  bottom: 0.6rem;\n  z-index: 110;\n  opacity: 0;\n  border-radius: 2rem;\n  -webkit-transform: translate(-50%, 100px);\n          transform: translate(-50%, 100px);\n  -webkit-transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n}\n.pages__2jlej.show__2Pu4e {\n  opacity: 0.8;\n  -webkit-transform: translate(-50%, 0);\n          transform: translate(-50%, 0);\n}\n.pages__2jlej.mobile__3HB5p {\n  bottom: 2rem;\n}\n.pages__2jlej .dot__p50eg {\n  cursor: pointer;\n  margin: 0.45rem 0.25rem;\n  display: block;\n  width: 0.6rem;\n  height: 0.6rem;\n  border-radius: 1.2rem;\n  background: black;\n  -webkit-transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), width 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), width 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), width 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), width 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n}\n.pages__2jlej .dot__p50eg:first-of-type {\n  margin-left: 0.6rem;\n}\n.pages__2jlej .dot__p50eg:last-of-type {\n  margin-right: 0.6rem;\n}\n.pages__2jlej .blackDot__TTF7k {\n  cursor: pointer;\n  margin: 0.45rem 0.25rem;\n  display: block;\n  width: 0.6rem;\n  height: 0.6rem;\n  border-radius: 1.2rem;\n  -webkit-transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), width 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), width 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), width 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), width 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  cursor: initial;\n  width: 1rem;\n  background: black;\n}\n.pages__2jlej .blackDot__TTF7k:first-of-type {\n  margin-left: 0.6rem;\n}\n.pages__2jlej .blackDot__TTF7k:last-of-type {\n  margin-right: 0.6rem;\n}\n.pages__2jlej .whiteDot__3iAb5 {\n  cursor: pointer;\n  margin: 0.45rem 0.25rem;\n  display: block;\n  width: 0.6rem;\n  height: 0.6rem;\n  border-radius: 1.2rem;\n  background: black;\n  -webkit-transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), width 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), width 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), width 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), width 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  background: #999;\n}\n.pages__2jlej .whiteDot__3iAb5:first-of-type {\n  margin-left: 0.6rem;\n}\n.pages__2jlej .whiteDot__3iAb5:last-of-type {\n  margin-right: 0.6rem;\n}\n.pages__2jlej .whiteDot__3iAb5:hover {\n  opacity: 0.8 !important;\n  -webkit-transform: scale(1.1) !important;\n          transform: scale(1.1) !important;\n}\n.pages__2jlej .whiteDot__3iAb5:active {\n  opacity: 1 !important;\n  -webkit-transform: scale(1) !important;\n          transform: scale(1) !important;\n}\n", ""]), e.locals = {
    baseButton: "baseButton__2AV5J",
    controls: "controls__NTVNu",
    show: "show__2Pu4e",
    pinButton: "pinButton__pLhHH",
    rotate: "rotate__18SVA",
    rotateLeft: "rotateLeft__1y4kO",
    rotateRight: "rotateRight__1GeTD",
    download: "download__TnaVI",
    zoom: "zoom__1W2_u",
    close: "close__h79Tx",
    sideButton: "sideButton__25vo1",
    flipLeft: "flipLeft__fhip_",
    flipRight: "flipRight__2T92B",
    pages: "pages__2jlej",
    mobile: "mobile__3HB5p",
    dot: "dot__p50eg",
    blackDot: "blackDot__TTF7k",
    whiteDot: "whiteDot__3iAb5"
  };
}, function (t, e, n) {
  (e = t.exports = n(3)(!1)).push([t.i, "/* 与 anim.js 同步 */\n.imageLayer__1NyU2 {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  -webkit-transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-clip-path 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-clip-path 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), clip-path 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), clip-path 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-clip-path 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  will-change: transform, top, opacity, clip-path;\n}\n.imageLayer__1NyU2.zooming__3TFmo {\n  -webkit-transition-timing-function: cubic-bezier(0, 0.1, 0.1, 1);\n          transition-timing-function: cubic-bezier(0, 0.1, 0.1, 1);\n  -ms-transition-duration: 0ms;\n}\n.imageLayer__1NyU2.invalidate__1wygJ {\n  opacity: 0 !important;\n  pointer-events: none;\n}\n", ""]), e.locals = {
    imageLayer: "imageLayer__1NyU2",
    zooming: "zooming__3TFmo",
    invalidate: "invalidate__1wygJ"
  };
}, function (t, e, n) {
  (e = t.exports = n(3)(!1)).push([t.i, "/* 与 anim.js 同步 */\n.loadingContainer__33QBo {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  opacity: 0;\n  -webkit-transition: opacity cubic-bezier(0.6, 0, 0.1, 1) 175ms;\n  transition: opacity cubic-bezier(0.6, 0, 0.1, 1) 175ms;\n}\n.loadingContainer__33QBo.show__1Bu8R {\n  opacity: 1;\n}\n.loadingContainer__33QBo .reload__3KDuO {\n  border: 2px solid;\n  border-radius: 5px;\n  font-size: 1rem;\n  padding: 0.5rem;\n  cursor: pointer;\n  outline: none;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n.loadingContainer__33QBo .reload__3KDuO:hover {\n  opacity: 0.8;\n}\n.loadingContainer__33QBo .reload__3KDuO:hover svg {\n  -webkit-transform: rotate(30deg);\n          transform: rotate(30deg);\n}\n.loadingContainer__33QBo .reload__3KDuO:active {\n  opacity: 1;\n}\n.loadingContainer__33QBo .reload__3KDuO svg {\n  display: block;\n  -webkit-transition: -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n}\n.loadingContainer__33QBo .loading__3UcNS {\n  width: 24px;\n  height: 24px;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-animation: spin__2VDbe 1s linear infinite;\n          animation: spin__2VDbe 1s linear infinite;\n}\n@-webkit-keyframes fadeIn__3TpcC {\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes fadeIn__3TpcC {\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@-webkit-keyframes fadeOut__9PHOR {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n@keyframes fadeOut__9PHOR {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n@-webkit-keyframes spin__2VDbe {\n  0% {\n    -webkit-transform: translate(-50%, -50%) rotate(0deg);\n            transform: translate(-50%, -50%) rotate(0deg);\n  }\n  100% {\n    -webkit-transform: translate(-50%, -50%) rotate(360deg);\n            transform: translate(-50%, -50%) rotate(360deg);\n  }\n}\n@keyframes spin__2VDbe {\n  0% {\n    -webkit-transform: translate(-50%, -50%) rotate(0deg);\n            transform: translate(-50%, -50%) rotate(0deg);\n  }\n  100% {\n    -webkit-transform: translate(-50%, -50%) rotate(360deg);\n            transform: translate(-50%, -50%) rotate(360deg);\n  }\n}\n", ""]), e.locals = {
    loadingContainer: "loadingContainer__33QBo",
    show: "show__1Bu8R",
    reload: "reload__3KDuO",
    loading: "loading__3UcNS",
    spin: "spin__2VDbe",
    fadeIn: "fadeIn__3TpcC",
    fadeOut: "fadeOut__9PHOR"
  };
}, function (t, e, n) {
  (e = t.exports = n(3)(!1)).push([t.i, "/* 与 anim.js 同步 */\n.backgroundLayer__36t43 {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  cursor: -webkit-zoom-out;\n  cursor: zoom-out;\n  background-color: #ffffff;\n  -webkit-transition: opacity 0.2s;\n  transition: opacity 0.2s;\n  will-change: opacity;\n  -webkit-tap-highlight-color: transparent;\n}\n", ""]), e.locals = {
    backgroundLayer: "backgroundLayer__36t43"
  };
}, function (t, e, n) {
  "use strict";

  n.r(e);
  var r = n(0),
    o = n.n(r),
    i = n(6),
    a = n.n(i),
    c = n(10),
    s = n.n(c),
    u = n(1),
    l = n.n(u),
    f = function (t) {
      if (window) {
        if (!window.hasOwnProperty("__ZMAGE_INITIALIZED___")) {
          var e = (n = navigator.userAgent || navigator.vendor || window.opera, /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(n) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(n.substr(0, 4)));
          window.__ZMAGE_INITIALIZED___ = !0, window.__ZMAGE_ENV_IS_DESKTOP___ = !e, window.__ZMAGE_ENV_IS_MOBILE___ = e;
        }
        return window[t];
      }
      var n;
    },
    p = {
      get isDesktop() {
        return f("__ZMAGE_ENV_IS_DESKTOP___") || !0;
      },
      get isMobile() {
        return f("__ZMAGE_ENV_IS_MOBILE___") || !1;
      }
    };
  function b(t, e) {
    var n = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(t);
      e && (r = r.filter(function (e) {
        return Object.getOwnPropertyDescriptor(t, e).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function m(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = null != arguments[e] ? arguments[e] : {};
      e % 2 ? b(n, !0).forEach(function (e) {
        y(t, e, n[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : b(n).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
      });
    }
    return t;
  }
  function y(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }
  var d = {
      src: l.a.oneOfType([l.a.string, l.a.func]),
      alt: l.a.string,
      txt: l.a.string,
      set: l.a.oneOfType([l.a.arrayOf(l.a.shape({
        src: l.a.string,
        alt: l.a.string,
        text: l.a.string
      })), l.a.shape({
        src: l.a.string,
        alt: l.a.string,
        text: l.a.string
      })]),
      defaultPage: l.a.number,
      preset: l.a.oneOf(["auto", "desktop", "mobile"]),
      controller: l.a.oneOfType([l.a.bool, l.a.shape({
        pagination: l.a.bool,
        rotate: l.a.bool,
        zoom: l.a.bool,
        close: l.a.bool,
        flip: l.a.bool
      })]),
      hotKey: l.a.oneOfType([l.a.bool, l.a.shape({
        close: l.a.bool,
        zoom: l.a.bool,
        flip: l.a.bool
      })]),
      animate: l.a.shape({
        browsing: l.a.bool,
        flip: l.a.oneOf(["fade", "crossFade", "swipe", "zoom"])
      }),
      coverVisible: l.a.bool,
      backdrop: l.a.string,
      zIndex: l.a.number,
      radius: l.a.number,
      edge: l.a.number,
      loop: l.a.bool,
      directZoom: l.a.bool,
      onBrowsing: l.a.func,
      onZooming: l.a.func,
      onSwitching: l.a.func,
      onRotating: l.a.func,
      browsing: l.a.bool
    },
    h = {
      desktop: {
        controller: {
          pagination: !0,
          rotate: !0,
          zoom: !0,
          download: !1,
          close: !0,
          flip: !0
        },
        hotKey: {
          close: !0,
          zoom: !0,
          flip: !0
        },
        animate: {
          browsing: !0,
          flip: "fade"
        }
      },
      mobile: {
        controller: {
          pagination: !0,
          rotate: !1,
          zoom: !1,
          download: !1,
          close: !0,
          flip: !1
        },
        hotKey: {
          close: !1,
          zoom: !1,
          flip: !1
        },
        animate: {
          browsing: !0,
          flip: "swipe"
        }
      }
    },
    g = {
      src: "",
      alt: "",
      txt: "",
      set: [],
      defaultPage: 0,
      preset: "auto",
      controller: {},
      hotKey: {},
      animate: {},
      coverVisible: !1,
      backdrop: "#FFFFFF",
      zIndex: 1e3,
      radius: 0,
      edge: 0,
      loop: !0,
      directZoom: !1,
      onBrowsing: function () {},
      onZooming: function () {},
      onSwitching: function () {},
      onRotating: function () {}
    },
    w = "__ZMAGE_DEF_PROP__",
    v = function (t) {
      if ("undefined" != typeof window) {
        if (window.hasOwnProperty(w) || (window[w] = {}), !window[w].hasOwnProperty(t)) switch (t) {
          case "desktop":
            window[w][t] = m({}, g, {}, h.desktop);
            break;
          case "mobile":
            window[w][t] = m({}, g, {}, h.mobile);
            break;
          case "auto":
            window[w][t] = m({}, g, {}, p.isDesktop && h.desktop, {}, p.isMobile && h.mobile);
            break;
          default:
            window[w][t] = m({}, g, {}, h.desktop);
        }
        return window[w][t];
      }
      return {};
    };
  function _(t) {
    return (_ = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }
  function O(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }
  function k(t, e) {
    return !e || "object" !== _(e) && "function" != typeof e ? function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }(t) : e;
  }
  function z(t) {
    return (z = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }
  function j(t, e) {
    return (j = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }
  var x = function (t) {
    function e(t) {
      var n;
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), (n = k(this, z(e).call(this, t))).target = t.target || document.body, n.container = document.createElement("figure"), n.container.id = t.id, n.container.className = t.className, n.container.style.zIndex = t.zIndex, n.target.appendChild(n.container), n;
    }
    var n, r, o;
    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && j(t, e);
    }(e, t), n = e, (r = [{
      key: "componentWillUnmount",
      value: function () {
        this.target.removeChild(this.container);
      }
    }, {
      key: "render",
      value: function () {
        var t = this.props.children;
        return a.a.createPortal(t, this.container);
      }
    }]) && O(n.prototype, r), o && O(n, o), e;
  }(o.a.PureComponent);
  x.defaultProps = {
    zIndex: g.zIndex
  }, x.propTypes = {
    id: l.a.string,
    className: l.a.string,
    zIndex: d.zIndex
  };
  var P = n(2),
    S = n.n(P);
  function E(t) {
    return (E = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }
  function T(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }
  function N(t, e) {
    return !e || "object" !== E(e) && "function" != typeof e ? function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }(t) : e;
  }
  function I(t) {
    return (I = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }
  function C(t, e) {
    return (C = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }
  var R = function (t) {
    function e() {
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), N(this, I(e).apply(this, arguments));
    }
    var n, r, i;
    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && C(t, e);
    }(e, t), n = e, (r = [{
      key: "render",
      value: function () {
        return o.a.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24"
        }, o.a.createElement("path", {
          d: "M14.71 15.88L10.83 12l3.88-3.88c.39-.39.39-1.02 0-1.41-.39-.39-1.02-.39-1.41 0L8.71 11.3c-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0 .38-.39.39-1.03 0-1.42z"
        }));
      }
    }]) && T(n.prototype, r), i && T(n, i), e;
  }(o.a.PureComponent);
  function L(t) {
    return (L = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }
  function V(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }
  function B(t, e) {
    return !e || "object" !== L(e) && "function" != typeof e ? function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }(t) : e;
  }
  function D(t) {
    return (D = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }
  function M(t, e) {
    return (M = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }
  var A = function (t) {
    function e() {
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), B(this, D(e).apply(this, arguments));
    }
    var n, r, i;
    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && M(t, e);
    }(e, t), n = e, (r = [{
      key: "render",
      value: function () {
        return o.a.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24"
        }, o.a.createElement("path", {
          d: "M9.29 15.88L13.17 12 9.29 8.12c-.39-.39-.39-1.02 0-1.41.39-.39 1.02-.39 1.41 0l4.59 4.59c.39.39.39 1.02 0 1.41L10.7 17.3c-.39.39-1.02.39-1.41 0-.38-.39-.39-1.03 0-1.42z"
        }));
      }
    }]) && V(n.prototype, r), i && V(n, i), e;
  }(o.a.PureComponent);
  function G(t) {
    return (G = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }
  function Z(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }
  function H(t, e) {
    return !e || "object" !== G(e) && "function" != typeof e ? function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }(t) : e;
  }
  function F(t) {
    return (F = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }
  function U(t, e) {
    return (U = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }
  var W = function (t) {
    function e() {
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), H(this, F(e).apply(this, arguments));
    }
    var n, r, i;
    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && U(t, e);
    }(e, t), n = e, (r = [{
      key: "render",
      value: function () {
        return o.a.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24"
        }, o.a.createElement("path", {
          fill: "none",
          d: "M0 0h24v24H0V0z"
        }), o.a.createElement("path", {
          d: "M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
        }));
      }
    }]) && Z(n.prototype, r), i && Z(n, i), e;
  }(o.a.PureComponent);
  function K(t) {
    return (K = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }
  function Y(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }
  function X(t, e) {
    return !e || "object" !== K(e) && "function" != typeof e ? function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }(t) : e;
  }
  function q(t) {
    return (q = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }
  function Q(t, e) {
    return (Q = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }
  var J = function (t) {
    function e() {
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), X(this, q(e).apply(this, arguments));
    }
    var n, r, i;
    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && Q(t, e);
    }(e, t), n = e, (r = [{
      key: "render",
      value: function () {
        return o.a.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24"
        }, o.a.createElement("path", {
          fill: "none",
          d: "M0 0h24v24H0V0z"
        }), o.a.createElement("path", {
          d: "M19 13v5c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1v-5c0-.55-.45-1-1-1s-1 .45-1 1v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6c0-.55-.45-1-1-1s-1 .45-1 1zm-6-.33l1.88-1.88c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-3.59 3.59c-.39.39-1.02.39-1.41 0L7.7 12.2c-.39-.39-.39-1.02 0-1.41.39-.39 1.02-.39 1.41 0L11 12.67V4c0-.55.45-1 1-1s1 .45 1 1v8.67z"
        }));
      }
    }]) && Y(n.prototype, r), i && Y(n, i), e;
  }(o.a.PureComponent);
  function $(t) {
    return ($ = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }
  function tt(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }
  function et(t, e) {
    return !e || "object" !== $(e) && "function" != typeof e ? function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }(t) : e;
  }
  function nt(t) {
    return (nt = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }
  function rt(t, e) {
    return (rt = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }
  var ot = function (t) {
    function e() {
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), et(this, nt(e).apply(this, arguments));
    }
    var n, r, i;
    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && rt(t, e);
    }(e, t), n = e, (r = [{
      key: "render",
      value: function () {
        return o.a.createElement("svg", {
          xmlns: "http://www.w3.org/1999/xlink",
          width: "24",
          height: "24",
          viewBox: "0 0 200 200",
          preserveAspectRatio: "xMinYMin meet"
        }, o.a.createElement("defs", null, o.a.createElement("linearGradient", {
          id: "spinner-1552570621916",
          x1: "0%",
          y1: "0%",
          x2: "65%",
          y2: "0%"
        }, o.a.createElement("stop", {
          offset: "0%",
          className: "Spinner-blue-3_W"
        }), o.a.createElement("stop", {
          offset: "100%",
          stopOpacity: "0"
        }))), o.a.createElement("circle", {
          cx: "100",
          cy: "100",
          r: "90",
          fill: "transparent",
          stroke: "url(#spinner-1552570621916)",
          strokeWidth: "20"
        }));
      }
    }]) && tt(n.prototype, r), i && tt(n, i), e;
  }(o.a.PureComponent);
  function it(t) {
    return (it = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }
  function at(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }
  function ct(t, e) {
    return !e || "object" !== it(e) && "function" != typeof e ? function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }(t) : e;
  }
  function st(t) {
    return (st = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }
  function ut(t, e) {
    return (ut = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }
  var lt = function (t) {
    function e() {
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), ct(this, st(e).apply(this, arguments));
    }
    var n, r, i;
    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && ut(t, e);
    }(e, t), n = e, (r = [{
      key: "render",
      value: function () {
        return o.a.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24"
        }, o.a.createElement("path", {
          fill: "none",
          d: "M0 0h24v24H0V0z"
        }), o.a.createElement("path", {
          d: "M12 6v1.79c0 .45.54.67.85.35l2.79-2.79c.2-.2.2-.51 0-.71l-2.79-2.79c-.31-.31-.85-.09-.85.36V4c-4.42 0-8 3.58-8 8 0 1.04.2 2.04.57 2.95.27.67 1.13.85 1.64.34.27-.27.38-.68.23-1.04C6.15 13.56 6 12.79 6 12c0-3.31 2.69-6 6-6zm5.79 2.71c-.27.27-.38.69-.23 1.04.28.7.44 1.46.44 2.25 0 3.31-2.69 6-6 6v-1.79c0-.45-.54-.67-.85-.35l-2.79 2.79c-.2.2-.2.51 0 .71l2.79 2.79c.31.31.85.09.85-.35V20c4.42 0 8-3.58 8-8 0-1.04-.2-2.04-.57-2.95-.27-.67-1.13-.85-1.64-.34z"
        }));
      }
    }]) && at(n.prototype, r), i && at(n, i), e;
  }(o.a.PureComponent);
  function ft(t) {
    return (ft = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }
  function pt(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }
  function bt(t, e) {
    return !e || "object" !== ft(e) && "function" != typeof e ? function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }(t) : e;
  }
  function mt(t) {
    return (mt = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }
  function yt(t, e) {
    return (yt = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }
  var dt = function (t) {
    function e() {
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), bt(this, mt(e).apply(this, arguments));
    }
    var n, r, i;
    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && yt(t, e);
    }(e, t), n = e, (r = [{
      key: "render",
      value: function () {
        return o.a.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24"
        }, o.a.createElement("path", {
          fill: "none",
          d: "M0 0h24v24H0V0z"
        }), o.a.createElement("path", {
          d: "M6.56 7.98C6.1 7.52 5.31 7.6 5 8.17c-.28.51-.5 1.03-.67 1.58-.19.63.31 1.25.96 1.25h.01c.43 0 .82-.28.94-.7.12-.4.28-.79.48-1.17.22-.37.15-.84-.16-1.15zM5.31 13h-.02c-.65 0-1.15.62-.96 1.25.16.54.38 1.07.66 1.58.31.57 1.11.66 1.57.2.3-.31.38-.77.17-1.15-.2-.37-.36-.76-.48-1.16-.12-.44-.51-.72-.94-.72zm2.85 6.02c.51.28 1.04.5 1.59.66.62.18 1.24-.32 1.24-.96v-.03c0-.43-.28-.82-.7-.94-.4-.12-.78-.28-1.15-.48-.38-.21-.86-.14-1.16.17l-.03.03c-.45.45-.36 1.24.21 1.55zM13 4.07v-.66c0-.89-1.08-1.34-1.71-.71L9.17 4.83c-.4.4-.4 1.04 0 1.43l2.13 2.08c.63.62 1.7.17 1.7-.72V6.09c2.84.48 5 2.94 5 5.91 0 2.73-1.82 5.02-4.32 5.75-.41.12-.68.51-.68.94v.02c0 .65.61 1.14 1.23.96C17.57 18.71 20 15.64 20 12c0-4.08-3.05-7.44-7-7.93z"
        }));
      }
    }]) && pt(n.prototype, r), i && pt(n, i), e;
  }(o.a.PureComponent);
  function ht(t) {
    return (ht = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }
  function gt(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }
  function wt(t, e) {
    return !e || "object" !== ht(e) && "function" != typeof e ? function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }(t) : e;
  }
  function vt(t) {
    return (vt = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }
  function _t(t, e) {
    return (_t = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }
  var Ot = function (t) {
    function e() {
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), wt(this, vt(e).apply(this, arguments));
    }
    var n, r, i;
    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && _t(t, e);
    }(e, t), n = e, (r = [{
      key: "render",
      value: function () {
        return o.a.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24"
        }, o.a.createElement("path", {
          fill: "none",
          d: "M0 0h24v24H0V0z"
        }), o.a.createElement("path", {
          d: "M14.83 4.83L12.7 2.7c-.62-.62-1.7-.18-1.7.71v.66C7.06 4.56 4 7.92 4 12c0 3.64 2.43 6.71 5.77 7.68.62.18 1.23-.32 1.23-.96v-.03c0-.43-.27-.82-.68-.94C7.82 17.03 6 14.73 6 12c0-2.97 2.16-5.43 5-5.91v1.53c0 .89 1.07 1.33 1.7.71l2.13-2.08c.4-.38.4-1.02 0-1.42zm4.84 4.93c-.16-.55-.38-1.08-.66-1.59-.31-.57-1.1-.66-1.56-.2l-.01.01c-.31.31-.38.78-.17 1.16.2.37.36.76.48 1.16.12.42.51.7.94.7h.02c.65 0 1.15-.62.96-1.24zM13 18.68v.02c0 .65.62 1.14 1.24.96.55-.16 1.08-.38 1.59-.66.57-.31.66-1.1.2-1.56l-.02-.02c-.31-.31-.78-.38-1.16-.17-.37.21-.76.37-1.16.49-.41.12-.69.51-.69.94zm4.44-2.65c.46.46 1.25.37 1.56-.2.28-.51.5-1.04.67-1.59.18-.62-.31-1.24-.96-1.24h-.02c-.44 0-.82.28-.94.7-.12.4-.28.79-.48 1.17-.21.38-.13.86.17 1.16z"
        }));
      }
    }]) && gt(n.prototype, r), i && gt(n, i), e;
  }(o.a.PureComponent);
  function kt(t) {
    return (kt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }
  function zt(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }
  function jt(t, e) {
    return !e || "object" !== kt(e) && "function" != typeof e ? function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }(t) : e;
  }
  function xt(t) {
    return (xt = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }
  function Pt(t, e) {
    return (Pt = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }
  var St = function (t) {
      function e() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e), jt(this, xt(e).apply(this, arguments));
      }
      var n, r, i;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Pt(t, e);
      }(e, t), n = e, (r = [{
        key: "render",
        value: function () {
          return o.a.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
          }, o.a.createElement("path", {
            fill: "none",
            d: "M0 0h24v24H0V0z"
          }), o.a.createElement("path", {
            d: "M6 14c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1H7v-2c0-.55-.45-1-1-1zm0-4c.55 0 1-.45 1-1V7h2c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm11 7h-2c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1s-1 .45-1 1v2zM14 6c0 .55.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1V6c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1z"
          }));
        }
      }]) && zt(n.prototype, r), i && zt(n, i), e;
    }(o.a.PureComponent),
    Et = Object(r.createContext)(),
    Tt = n(8),
    Nt = n.n(Tt);
  function It(t) {
    return function (t) {
      if (Array.isArray(t)) {
        for (var e = 0, n = new Array(t.length); e < t.length; e++) n[e] = t[e];
        return n;
      }
    }(t) || function (t) {
      if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
    }(t) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }();
  }
  function Ct(t, e) {
    var n = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(t);
      e && (r = r.filter(function (e) {
        return Object.getOwnPropertyDescriptor(t, e).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function Rt(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = null != arguments[e] ? arguments[e] : {};
      e % 2 ? Ct(n, !0).forEach(function (e) {
        Lt(t, e, n[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Ct(n).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
      });
    }
    return t;
  }
  function Lt(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }
  var Vt = function (t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
        r = t + 2 * n,
        o = e + 2 * n,
        i = r > Dt() ? Dt() / (t + 2 * n) : 1,
        a = o > At() ? At() / (e + 2 * n) : 1;
      return Math.min(i, a);
    },
    Bt = function () {
      return document.body.scrollWidth;
    },
    Dt = function () {
      return document.documentElement.clientWidth;
    },
    Mt = function () {
      return window.innerHeight;
    },
    At = function () {
      return document.documentElement.clientHeight;
    },
    Gt = {
      html: {},
      body: {}
    },
    Zt = function (t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
        n = arguments.length > 2 ? arguments[2] : void 0;
      return e && n ? "".concat(t, " ").concat(n) : t;
    },
    Ht = function (t, e) {
      var n;
      return n = setInterval(function () {
        t && !t.complete || (clearInterval(n), e && e());
      }, 500);
    },
    Ft = function (t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        n = Object.keys(e).reduce(function (t, n) {
          return e[n] ? t.concat("".concat(n, "=").concat(e[n])) : t;
        }, []).join("&");
      return n ? "".concat(t).concat(t.includes("?") ? "&" : "?").concat(n) : t;
    },
    Ut = Nt()(function (t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        n = e.ref,
        r = void 0 === n ? 100 : n;
      return t ? t.includes("%") ? r * Number(t.substring(0, t.length - 1)) / 100 : Number(t.substring(0, t.length - 2)) : t;
    }),
    Wt = Nt()(function (t) {
      var e = ["Webkit", "Moz", "Ms", "O"];
      return Object.keys(t).reduce(function (n, r) {
        var o = e.reduce(function (e, n) {
          return Rt({}, e, Lt({}, "".concat(n).concat((o = r).charAt(0).toUpperCase() + o.slice(1)), t[r]));
          var o;
        }, {});
        return Rt({}, n, {}, o);
      }, t);
    }),
    Kt = function (t) {
      return (0 ^ t) === t;
    },
    Yt = function (t, e, n) {
      var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
        loop: !0
      };
      return 0 === e ? 0 : 0 === n ? t : t < 0 || t > e - 1 ? void 0 : r.loop ? Math.abs(e + n + t) % e : t + n < 0 || t + n > e - 1 ? void 0 : t + n;
    },
    Xt = Nt()(function (t) {
      return [].concat(It(It(Array(t).keys()).map(function (t) {
        return -t - 1;
      }).reverse()), It(Array(t + 1).keys()));
    });
  function qt(t) {
    return (qt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }
  function Qt(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }
  function Jt(t) {
    return (Jt = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }
  function $t(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }
  function te(t, e) {
    return (te = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }
  function ee(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }
  var ne = function (t) {
    function e() {
      var t, n, r, o;
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);
      for (var i = arguments.length, a = new Array(i), c = 0; c < i; c++) a[c] = arguments[c];
      return r = this, o = (t = Jt(e)).call.apply(t, [this].concat(a)), n = !o || "object" !== qt(o) && "function" != typeof o ? $t(r) : o, ee($t(n), "withShow", function (t) {
        var e = n.props,
          r = e.show,
          o = e.zoom;
        return Zt(t, !o && r, S.a.show);
      }), ee($t(n), "withMobile", function (t) {
        var e = n.context.presetIsMobile;
        return Zt(t, e, S.a.mobile);
      }), n;
    }
    var n, i, a;
    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && te(t, e);
    }(e, t), n = e, (i = [{
      key: "render",
      value: function () {
        var t = this,
          e = this.context,
          n = e.set,
          i = (e.preset, e.presetIsMobile),
          a = (e.presetIsDesktop, e.controller),
          c = e.backdrop,
          s = e.loop,
          u = e.zoom,
          l = e.page,
          f = e.outBrowsing,
          p = e.toPage,
          b = e.toPrevPage,
          m = e.toNextPage,
          y = e.toggleZoom,
          d = e.toggleRotate;
        return o.a.createElement(r.Fragment, null, o.a.createElement("div", {
          id: "zmageControl",
          className: this.withShow(S.a.controls),
          style: {
            backgroundColor: c
          }
        }, a.rotate && o.a.createElement("div", {
          id: "zmageControlRotateLeft",
          className: this.withShow(S.a.rotateLeft),
          onClick: d("left")
        }, o.a.createElement(dt, null)), a.rotate && o.a.createElement("div", {
          id: "zmageControlRotateRight",
          className: this.withShow(S.a.rotateRight),
          onClick: d("right")
        }, o.a.createElement(Ot, null)), a.download && o.a.createElement("div", {
          id: "zmageControlDownload",
          className: this.withShow(S.a.download),
          onClick: function () {
            return e = t.context.set[t.context.page].src, (r = document.createElement("a")).href = e, r.download = n || e.split("/")[e.split("/").length - 1], document.body.appendChild(r), r.click(), void document.body.removeChild(r);
            var e, n, r;
          }
        }, o.a.createElement(J, null)), a.zoom && o.a.createElement("div", {
          id: "zmageControlZoom",
          className: this.withShow(S.a.zoom),
          onClick: i ? function () {
            return window.open(n[l].src);
          } : y
        }, o.a.createElement(St, null)), a.close && o.a.createElement("div", {
          id: "zmageControlClose",
          className: this.withShow(S.a.close),
          onClick: u ? y : f
        }, o.a.createElement(W, null))), Array.isArray(n) && n.length > 1 && a.flip && o.a.createElement(r.Fragment, null, (s || 0 !== l) && o.a.createElement("div", {
          id: "zmageControlFlipLeft",
          className: this.withShow(S.a.flipLeft),
          style: {
            backgroundColor: c
          },
          onClick: b
        }, o.a.createElement(R, null)), (s || l !== n.length - 1) && o.a.createElement("div", {
          id: "zmageControlFlipRight",
          className: this.withShow(S.a.flipRight),
          style: {
            backgroundColor: c
          },
          onClick: m
        }, o.a.createElement(A, null))), Array.isArray(n) && n.length > 1 && a.pagination && o.a.createElement("div", {
          id: "zmageControlPagination",
          className: this.withMobile(this.withShow(S.a.pages)),
          style: {
            backgroundColor: c
          }
        }, n.map(function (t, e) {
          return e === l ? o.a.createElement("span", {
            key: e,
            id: "zmageControlPaginationActive",
            className: S.a.blackDot
          }) : o.a.createElement("span", {
            key: e,
            className: S.a.whiteDot,
            onClick: function () {
              return p(e);
            }
          });
        })));
      }
    }]) && Qt(n.prototype, i), a && Qt(n, a), e;
  }(o.a.PureComponent);
  ne.contextType = Et;
  var re = n(7),
    oe = n.n(re),
    ie = n(9),
    ae = n.n(ie),
    ce = n(5),
    se = n.n(ce);
  function ue(t) {
    return (ue = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }
  function le(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }
  function fe(t, e) {
    return !e || "object" !== ue(e) && "function" != typeof e ? function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }(t) : e;
  }
  function pe(t) {
    return (pe = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }
  function be(t, e) {
    return (be = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }
  var me = function (t) {
    function e() {
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), fe(this, pe(e).apply(this, arguments));
    }
    var n, i, a;
    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && be(t, e);
    }(e, t), n = e, (i = [{
      key: "render",
      value: function () {
        var t,
          e,
          n,
          i = this.props,
          a = i.show,
          c = i.load,
          s = i.invalidate,
          u = i.onReload,
          l = i.backdrop,
          f = oe()(se.a.loadingContainer, (t = {}, e = se.a.show, n = a, e in t ? Object.defineProperty(t, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : t[e] = n, t));
        return o.a.createElement(r.Fragment, null, (c || s) && o.a.createElement("div", {
          id: "zmageLoading",
          className: f
        }, c && o.a.createElement("div", {
          className: se.a.loading
        }, o.a.createElement(ot, null)), s && o.a.createElement("button", {
          className: se.a.reload,
          onClick: u,
          style: {
            background: l
          }
        }, o.a.createElement(lt, null))));
      }
    }]) && le(n.prototype, i), a && le(n, a), e;
  }(o.a.PureComponent);
  me.contextType = Et;
  var ye = function (t, e, n) {
      var r = t.show,
        o = e.zoom;
      return r ? o ? ge(t, e, n) : he(t, e, n) : de(t, e);
    },
    de = function (t, e) {
      var n = e.coverRef,
        r = e.coverPos,
        o = e.rotate,
        i = e.pageIsCover;
      if (n.current) {
        var a = n.current.naturalWidth,
          c = n.current.getBoundingClientRect(),
          s = c.top,
          u = c.left,
          l = c.width,
          f = c.height,
          p = window.getComputedStyle(n.current),
          b = p.opacity,
          m = p.borderRadius;
        return i ? {
          _type: "cover",
          x: -Bt() / 2 + u + l / 2,
          y: -Mt() / 2 + s + f / 2,
          opacity: Number(b) || 1,
          scale: a ? l / a : 1,
          rotate: o - o % 360,
          radius: Ut(m, {
            ref: l
          })
        } : {
          _type: "cover",
          x: 0,
          y: -Mt(),
          opacity: 0,
          scale: a ? l / a : 1,
          rotate: o - o % 360,
          radius: Ut(m, {
            ref: l
          })
        };
      }
      return r ? {
        _type: "cover",
        x: r.x ? r.x - Bt() / 2 : 0,
        y: r.y ? r.y - Mt() / 2 : 0,
        opacity: 0,
        scale: 0,
        rotate: 0,
        radius: 0
      } : {
        _type: "cover",
        x: 0,
        y: 0,
        opacity: 0,
        scale: 0,
        rotate: 0,
        radius: 0
      };
    },
    he = function (t, e, n) {
      var r = e.radius,
        o = e.edge,
        i = e.rotate,
        a = n.current,
        c = a.naturalWidth,
        s = a.naturalHeight;
      return {
        _type: "browsing",
        x: 0,
        y: 0,
        opacity: 1,
        scale: Vt(c, s, o),
        rotate: i,
        radius: r
      };
    },
    ge = function (t, e, n) {
      var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
        o = r.clientX,
        i = void 0 === o ? Bt() / 2 : o,
        a = r.clientY,
        c = void 0 === a ? Mt() / 2 : a,
        s = e.radius,
        u = e.edge,
        l = e.rotate,
        f = n.current,
        p = f.naturalWidth,
        b = f.naturalHeight,
        m = u || 50,
        y = Bt(),
        d = Mt(),
        h = p - y + 2 * m,
        g = b - d + 2 * m,
        w = p > y ? (p - y) / 2 + m - h * (i / y) : 0,
        v = b > d ? (b - d) / 2 + m - g * (c / d) : 0;
      return {
        _type: "zooming",
        x: w,
        y: v,
        opacity: 1,
        scale: 1,
        rotate: l,
        radius: s
      };
    },
    we = {
      BEGIN: "BEGIN",
      MOVING: "MOVING",
      END: "END"
    },
    ve = {
      SWIPING: "SWIPING",
      LIVING: "LIVING"
    },
    _e = function () {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        e = t.origin;
      return {
        phase: we.BEGIN,
        behavior: void 0,
        begin: {
          time: new Date().getTime(),
          origin: e || {
            x: 0,
            y: 0
          },
          offset: {
            x: 0,
            y: 0
          }
        },
        current: {
          time: new Date().getTime(),
          origin: e || {
            x: 0,
            y: 0
          },
          offset: {
            x: 0,
            y: 0
          }
        },
        update: function () {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = t.origin;
          if (this.phase = we.MOVING, this.current = {
            time: new Date().getTime(),
            origin: e,
            offset: {
              x: e.x - this.begin.origin.x,
              y: e.y - this.begin.origin.y
            }
          }, !this.behavior) {
            var n = Math.abs(this.current.offset.x),
              r = Math.abs(this.current.offset.y);
            n > r ? n > 10 && (this.behavior = ve.SWIPING) : r > 10 && (this.behavior = ve.LIVING);
          }
          return this;
        },
        end: function () {
          var t = new Date().getTime();
          return this.phase = we.END, t - this.current.time > 1e3 && this.behavior && (this.behavior === ve.SWIPING && this.current.offset.x < 200 ? this.behavior = void 0 : this.behavior === ve.LIVING && this.current.offset.y < 200 && (this.behavior = void 0)), this;
        }
      };
    };
  function Oe(t) {
    return (Oe = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }
  function ke() {
    return (ke = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = arguments[e];
        for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
      }
      return t;
    }).apply(this, arguments);
  }
  function ze(t, e) {
    var n = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(t);
      e && (r = r.filter(function (e) {
        return Object.getOwnPropertyDescriptor(t, e).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function je(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = null != arguments[e] ? arguments[e] : {};
      e % 2 ? ze(n, !0).forEach(function (e) {
        Te(t, e, n[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ze(n).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
      });
    }
    return t;
  }
  function xe(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }
  function Pe(t) {
    return (Pe = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }
  function Se(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }
  function Ee(t, e) {
    return (Ee = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }
  function Te(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }
  var Ne = function (t) {
    function e(t, n) {
      var r, i, a;
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), i = this, a = Pe(e).call(this, t), r = !a || "object" !== Oe(a) && "function" != typeof a ? Se(i) : a, Te(Se(r), "updateZoomEventListenerWithState", function () {
        var t = r.context,
          e = t.show,
          n = t.zoom;
        e && n && !r.listeningMouseMove ? (window.addEventListener("mousemove", r.handleMouseMove), r.listeningMouseMove = !0) : (window.removeEventListener("mousemove", r.handleMouseMove), r.listeningMouseMove = !1);
      }), Te(Se(r), "updateCurrentImageStyle", function () {
        var t = ye(r.props, r.context, r.imageRef);
        r.setCurrentStyle(t);
      }), Te(Se(r), "handleResize", function () {
        r.updateCurrentImageStyle();
      }), Te(Se(r), "handleScroll", function () {
        if (r.imageRef.current) {
          var t = r.context.show;
          r.imageRef.current.style.top = "calc(50% + ".concat(t ? 0 : r.initialPageOffset - window.pageYOffset, "px)");
        }
      }), Te(Se(r), "handleClick", function () {
        var t = r.context,
          e = t.zoom,
          n = t.toggleZoom;
        e && n();
      }), Te(Se(r), "handleTouchStart", function (t) {
        var e = t.touches[0],
          n = e.clientX,
          o = e.clientY;
        r.setTouchStyle(new _e({
          origin: {
            x: n,
            y: o
          }
        }));
      }), Te(Se(r), "handleTouchMove", function (t) {
        var e = r.state.touchStyle,
          n = t.touches[0],
          o = n.clientX,
          i = n.clientY;
        r.setTouchStyle(e.update({
          origin: {
            x: o,
            y: i
          }
        }));
      }), Te(Se(r), "handleTouchEnd", function (t) {
        var e = r.state.touchStyle;
        r.setTouchStyle(e.end());
      }), Te(Se(r), "handleMouseMove", function (t) {
        var e = ge(r.props, r.context, r.imageRef, t);
        r.setCurrentStyle(e);
      }), Te(Se(r), "handleImageLoadStart", function () {
        r.setState({
          isFetching: !0,
          invalidate: !1
        }, r.handleDetectImageLoadComplete);
      }), Te(Se(r), "handleDetectImageLoadComplete", function () {
        clearInterval(r.imageLoadingTimer), r.imageLoadingTimer = Ht(r.imageRef.current, r.handleImageLoadEnd);
      }), Te(Se(r), "handleImageLoadEnd", function () {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          e = t.invalidate;
        clearInterval(r.imageLoadingTimer), r.setState({
          isFetching: !1,
          invalidate: void 0 === e ? r.state.invalidate : e
        });
      }), Te(Se(r), "handleImageLoad", function () {
        r.updateCurrentImageStyle();
      }), Te(Se(r), "handleImageError", function () {
        r.handleImageLoadEnd({
          invalidate: !0
        });
      }), Te(Se(r), "handleImageAbort", function () {
        r.handleImageLoadEnd({
          invalidate: !0
        });
      }), Te(Se(r), "handleImageReload", function () {
        var t = r.context.page;
        r.handleSetTimestamp(t);
      }), Te(Se(r), "handleSetTimestamp", function (t) {
        var e = r.context.set,
          n = r.state.timestamp;
        r.setState({
          timestamp: je({}, n, Te({}, e[t].src, new Date().getTime()))
        });
      }), Te(Se(r), "handleGetTimestamp", function (t) {
        var e = r.context.set;
        return r.state.timestamp[e[t].src];
      }), Te(Se(r), "setCurrentStyle", function (t) {
        r.setState({
          currentStyle: t
        });
      }), Te(Se(r), "setTouchStyle", function (t) {
        r.setState({
          touchStyle: je({}, t)
        }, function () {
          var t = r.context,
            e = t.outBrowsing,
            n = t.toPrevPage,
            o = t.toNextPage,
            i = r.state.touchStyle;
          i.phase === we.END && (i.behavior === ve.SWIPING ? i.current.offset.x < 0 ? o() : n() : i.behavior === ve.LIVING && e());
        });
      }), Te(Se(r), "getStyle", function (t, e, n) {
        var o,
          i,
          a,
          c,
          s,
          u = r.context,
          l = u.animate,
          f = u.set,
          p = u.zoom,
          b = u.page,
          m = r.state,
          y = m.invalidate,
          d = m.currentStyle,
          h = m.touchStyle,
          g = 0,
          w = 0,
          v = "fade" === l.flip,
          _ = "crossFade" === l.flip;
        _ && (g = 30), "swipe" === l.flip && (g = Bt() * t);
        var O = "zoom" === l.flip;
        O && (w = .08);
        var k = {
          x: 0,
          y: 0
        };
        return h && h.phase === we.MOVING && (h.behavior === ve.SWIPING ? (k.x = h.current.offset.x, s = "none") : h.behavior === ve.LIVING && (k.y = h.current.offset.y, s = "none")), n ? (o = "translate3d(-50%, -50%, 0) translate3d(".concat(d.x + k.x + g, "px, ").concat(d.y, "px, 0px) scale3d(").concat(d.scale + w, ", ").concat(d.scale + w, ", 1) rotate3d(0, 0, 1, 0deg)"), i = 10 * e, a = v || _ || O ? 0 : 1, c = "none") : (o = "translate3d(-50%, -50%, 0) translate3d(".concat(d.x + k.x, "px, ").concat(d.y + k.y, "px, 0px) scale3d(").concat(d.scale, ", ").concat(d.scale, ", 1) rotate3d(0, 0, 1, ").concat(d.rotate, "deg)"), a = d.opacity, i = 10), je({}, Wt({
          transform: o
        }), {
          cursor: p ? "zoom-out" : "initial",
          zIndex: i,
          opacity: y ? 0 : a,
          pointerEvents: c,
          transition: s
        }, f[b].style);
      }), Te(Se(r), "buildImageSeries", function (t) {
        return Xt(t).map(function (t) {
          return r.buildImage(t);
        });
      }), Te(Se(r), "buildImage", function (t) {
        var e = r.context,
          n = e.loop,
          i = e.set,
          a = e.show,
          c = e.zoom,
          s = e.page,
          u = e.pageWithStep,
          l = r.state.invalidate,
          f = Math.abs(t),
          p = f > 0,
          b = u + t,
          m = Yt(s, i.length, t, {
            loop: n
          });
        if (Kt(m)) {
          var y,
            d = r.getStyle(t, f, p),
            h = oe()(ae.a.imageLayer, i[m].className, (Te(y = {}, ae.a.zooming, c), Te(y, ae.a.invalidate, l), y)),
            g = {
              key: "".concat(b, "-").concat(i[m].src),
              style: d,
              className: h,
              src: Ft(i[m].src, {
                t: r.handleGetTimestamp(s)
              }),
              alt: i[m].alt
            },
            w = {
              id: "zmageImage",
              ref: r.imageRef,
              onLoad: r.handleImageLoad,
              onError: r.handleImageError,
              onAbort: r.handleImageAbort,
              onClick: r.handleClick
            };
          return p ? a && i.length > 1 && !c && o.a.createElement("img", g) : o.a.createElement("img", ke({}, g, w));
        }
      }), r.imageRef = o.a.createRef(), r.initialPageOffset = window.pageYOffset, r.listeningMouseMove = !1, r.imageLoadingTimer = null, r.state = {
        isFetching: !0,
        invalidate: !1,
        currentStyle: de(t, n),
        touchStyle: new _e(),
        timestamp: {}
      }, r;
    }
    var n, i, a;
    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && Ee(t, e);
    }(e, t), n = e, (i = [{
      key: "componentDidMount",
      value: function () {
        var t = this,
          e = this.context,
          n = e.presetIsMobile,
          r = e.presetIsDesktop;
        window.addEventListener("resize", this.handleResize), n && setTimeout(function () {
          window.addEventListener("touchstart", t.handleTouchStart), window.addEventListener("touchmove", t.handleTouchMove), window.addEventListener("touchend", t.handleTouchEnd);
        }, 0), r && setTimeout(function () {
          window.addEventListener("scroll", t.handleScroll);
        }, 0);
      }
    }, {
      key: "componentDidUpdate",
      value: function (t) {
        var e = t.show,
          n = t.zoom,
          r = t.rotate,
          o = t.page,
          i = this.props,
          a = i.show,
          c = i.zoom,
          s = i.rotate,
          u = i.page,
          l = this.context.presetIsMobile;
        e === a && n === c && r === s || (e ? (this.updateCurrentImageStyle(), l && (document.documentElement.style.overflow = Gt.html.overflow, document.body.style.overflow = Gt.body.overflow, document.body.style.position = Gt.body.position)) : (this.updateCurrentImageStyle(), this.handleDetectImageLoadComplete(), l && (Gt.html.overflow = document.documentElement.style.overflow, Gt.body.overflow = document.body.style.overflow, Gt.body.position = document.body.style.position, document.documentElement.style.overflow = "hidden", document.body.style.overflow = "hidden", document.body.style.position = "relative")), this.updateZoomEventListenerWithState()), o !== u && this.handleImageLoadStart();
      }
    }, {
      key: "componentWillUnmount",
      value: function () {
        var t = this.context,
          e = t.presetIsMobile,
          n = t.presetIsDesktop;
        e && (window.removeEventListener("touchstart", this.handleTouchStart), window.removeEventListener("touchmove", this.handleTouchMove), window.removeEventListener("touchend", this.handleTouchEnd)), n && window.removeEventListener("scroll", this.handleScroll), window.removeEventListener("resize", this.handleResize), window.removeEventListener("mousemove", this.handleMouseMove), clearInterval(this.imageLoadingTimer);
      }
    }, {
      key: "render",
      value: function () {
        var t = this.context,
          e = (t.set, t.show),
          n = (t.zoom, t.page, t.pageIsCover),
          i = (t.pageWithStep, this.state),
          a = i.isFetching,
          c = i.invalidate;
        return o.a.createElement(r.Fragment, null, o.a.createElement(me, {
          show: e && (!n || c),
          load: a,
          invalidate: c,
          onReload: this.handleImageReload
        }), this.buildImageSeries(2));
      }
    }]) && xe(n.prototype, i), a && xe(n, a), e;
  }(o.a.PureComponent);
  Ne.contextType = Et;
  var Ie = n(11),
    Ce = n.n(Ie);
  function Re(t) {
    return (Re = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }
  function Le(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }
  function Ve(t, e) {
    return !e || "object" !== Re(e) && "function" != typeof e ? function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }(t) : e;
  }
  function Be(t) {
    return (Be = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }
  function De(t, e) {
    return (De = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }
  var Me = function (t) {
    function e() {
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), Ve(this, Be(e).apply(this, arguments));
    }
    var n, r, i;
    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && De(t, e);
    }(e, t), n = e, (r = [{
      key: "render",
      value: function () {
        var t = this.props,
          e = t.show,
          n = t.zoom,
          r = this.context,
          i = r.backdrop,
          a = r.outBrowsing,
          c = r.toggleZoom;
        return o.a.createElement("div", {
          id: "zmageBackground",
          className: Ce.a.backgroundLayer,
          onClick: n ? c : a,
          style: {
            opacity: e ? 1 : 0,
            background: i || "",
            transitionDelay: e ? ".3s" : "0s"
          }
        });
      }
    }]) && Le(n.prototype, r), i && Le(n, i), e;
  }(o.a.Component);
  Me.contextType = Et;
  var Ae = 350,
    Ge = function (t, e, n) {
      return 0 === n || t && t.current && t.current.getAttribute("src") === e[n].src;
    },
    Ze = function (t, e, n) {
      var r = function (t, e) {
        return Kt(t) && t < e.length - 1 ? t : e.length - 1;
      }(e, n);
      return {
        page: r,
        pageIsCover: Ge(t, n, r)
      };
    },
    He = function (t) {
      t.current && t && t.current && (t.current.style.visibility = "visible");
    },
    Fe = function (t) {
      setTimeout(function () {
        t.current && t && t.current && (t.current.style.visibility = "hidden");
      }, 50);
    };
  function Ue(t) {
    return (Ue = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }
  function We(t, e) {
    var n = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(t);
      e && (r = r.filter(function (e) {
        return Object.getOwnPropertyDescriptor(t, e).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function Ke(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = null != arguments[e] ? arguments[e] : {};
      e % 2 ? We(n, !0).forEach(function (e) {
        Je(t, e, n[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : We(n).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
      });
    }
    return t;
  }
  function Ye(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }
  function Xe(t) {
    return (Xe = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }
  function qe(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }
  function Qe(t, e) {
    return (Qe = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }
  function Je(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }
  var $e = function (t) {
    function e(t) {
      var n, r, o;
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), r = this, o = Xe(e).call(this, t), n = !o || "object" !== Ue(o) && "function" != typeof o ? qe(r) : o, Je(qe(n), "init", function () {
        var t = n.props,
          e = t.isBrowsingControlled,
          r = t.coverRef,
          o = t.set,
          i = t.onBrowsing,
          a = t.coverVisible,
          c = t.directZoom,
          s = n.state,
          u = s.show,
          l = s.page,
          f = s.pageIsCover;
        u || (window.addEventListener("keydown", n.handleKeyDown), window.addEventListener("scroll", n.handleScroll), window.requestAnimationFrame(function () {
          n.setState({
            show: !0,
            zoom: c,
            rotate: 0
          }, function () {
            f && !a && Fe(r, o, l), !e && "function" == typeof i && i(!0);
          });
        }));
      }), Je(qe(n), "unInit", function () {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          e = t.force,
          r = n.props,
          o = r.isBrowsingControlled,
          i = r.coverRef,
          a = r.set,
          c = r.onBrowsing,
          s = r.coverVisible,
          u = n.state,
          l = u.show,
          f = u.page,
          p = u.pageIsCover;
        (l || e) && (window.removeEventListener("keydown", n.handleKeyDown), window.removeEventListener("scroll", n.handleScroll), !p && !s && He(i, a, f), n.setState({
          show: !1,
          zoom: !1,
          rotate: 0
        }, function () {
          return setTimeout(function () {
            n.setState({
              mount: !1
            }, function () {
              p && !s && He(i, a, f), !o && "function" == typeof c && c(!1);
            });
          }, Ae);
        }));
      }), Je(qe(n), "handleKeyDown", function (t) {
        var e = n.props,
          r = e.preset,
          o = e.set,
          i = e.hotKey,
          a = e.loop,
          c = e.outBrowsing,
          s = n.state,
          u = s.zoom,
          l = s.page,
          f = Ke({}, v(r).hotKey, {}, i);
        switch (t.keyCode) {
          case 27:
            t.preventDefault(), f.close && (u ? n.handleToggleZoom() : c());
            break;
          case 32:
            t.preventDefault(), f.zoom && n.handleToggleZoom();
            break;
          case 37:
            t.preventDefault(), (a || 0 !== l) && !u && f.flip && n.handleToPrevPage();
            break;
          case 39:
            t.preventDefault(), (a || l !== o.length - 1) && !u && f.flip && n.handleToNextPage();
            break;
          default:
            return;
        }
      }), Je(qe(n), "handleScroll", function () {
        n.state.show && n.props.outBrowsing();
      }), Je(qe(n), "handleToPage", function (t) {
        var e = n.state.page;
        n.handleSwitchPages(t - e)();
      }), Je(qe(n), "handleSwitchPages", function (t) {
        var e = n.props,
          r = e.coverRef,
          o = e.onSwitching,
          i = e.loop;
        return function () {
          var e = n.props.set;
          if (e.length > 1) {
            var a = n.state,
              c = a.page,
              s = a.pageWithStep,
              u = Yt(c, e.length, t, {
                loop: i
              });
            "number" == typeof u && n.setState({
              page: u,
              pageIsCover: Ge(r, e, u),
              pageWithStep: s + t,
              zoom: !1,
              rotate: 0
            }, function () {
              "function" == typeof o && o(u);
            });
          }
        };
      }), Je(qe(n), "handleToPrevPage", n.handleSwitchPages(-1)), Je(qe(n), "handleToNextPage", n.handleSwitchPages(1)), Je(qe(n), "handleToggleZoom", function () {
        var t = n.props.onZooming;
        n.props.directZoom && n.state.zoom && n.props.outBrowsing(), n.setState({
          zoom: !n.state.zoom
        }, function () {
          "function" == typeof t && t(n.state.zoom);
        });
      }), Je(qe(n), "handleToggleRotate", function (t) {
        var e = n.props.onRotating;
        switch (t) {
          case "left":
            return function () {
              return n.setState({
                rotate: n.state.rotate - 90
              }, function () {
                "function" == typeof e && e(n.state.rotate);
              });
            };
          case "right":
            return function () {
              return n.setState({
                rotate: n.state.rotate + 90
              }, function () {
                "function" == typeof e && e(n.state.rotate);
              });
            };
          default:
            return function () {
              return n.setState({
                rotate: 0
              }, function () {
                "function" == typeof e && e(0);
              });
            };
        }
      });
      var i = Ze(t.coverRef, t.defaultPage, t.set),
        a = i.page,
        c = i.pageIsCover;
      return n.state = {
        mount: !1,
        show: !1,
        zoom: !1,
        rotate: 0,
        page: a,
        pageIsCover: c,
        pageWithStep: a
      }, n;
    }
    var n, r, i;
    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && Qe(t, e);
    }(e, t), n = e, i = [{
      key: "getDerivedStateFromProps",
      value: function (t, e) {
        return t.browsing ? Ke({
          mount: !0
        }, e.show ? {} : Ze(t.coverRef, t.defaultPage, t.set)) : null;
      }
    }], (r = [{
      key: "componentDidMount",
      value: function () {
        this.props.browsing && this.init();
      }
    }, {
      key: "componentDidUpdate",
      value: function (t) {
        t.browsing !== this.props.browsing && (this.props.browsing ? this.init() : this.unInit());
      }
    }, {
      key: "componentWillUnmount",
      value: function () {
        this.unInit({
          force: !0
        });
      }
    }, {
      key: "render",
      value: function () {
        var t = this.props,
          e = t.coverRef,
          n = t.coverPos,
          r = t.outBrowsing,
          i = t.set,
          a = t.preset,
          c = t.controller,
          u = t.hotKey,
          l = t.animate,
          f = (t.coverVisible, t.backdrop),
          b = t.zIndex,
          m = t.radius,
          y = t.edge,
          d = t.loop,
          h = this.state,
          g = h.mount,
          w = h.show,
          _ = h.zoom,
          O = h.rotate,
          k = h.page,
          z = h.pageIsCover,
          j = h.pageWithStep,
          P = v(a),
          S = {
            show: w,
            zoom: _,
            rotate: O,
            page: k,
            pageIsCover: z,
            pageWithStep: j
          },
          E = Ke({
            coverRef: e,
            coverPos: n,
            outBrowsing: r,
            set: i,
            preset: a,
            presetIsMobile: "mobile" === a || "auto" === a && p.isMobile,
            presetIsDesktop: "desktop" === a || "auto" === a && p.isDesktop,
            controller: Ke({}, P.controller, {}, c),
            hotKey: Ke({}, P.hotKey, {}, u),
            animate: Ke({}, P.animate, {}, l),
            backdrop: f,
            radius: m,
            edge: y,
            loop: d
          }, S, {
            toPage: this.handleToPage,
            toPrevPage: this.handleToPrevPage,
            toNextPage: this.handleToNextPage,
            toggleZoom: this.handleToggleZoom,
            toggleRotate: this.handleToggleRotate
          });
        return o.a.createElement(Et.Provider, {
          value: E
        }, g && o.a.createElement(x, {
          id: "zmage",
          zIndex: b,
          className: s.a.wrapperLayer
        }, o.a.createElement(Me, S), o.a.createElement(ne, S), o.a.createElement(Ne, S)));
      }
    }]) && Ye(n.prototype, r), i && Ye(n, i), e;
  }(o.a.PureComponent);
  $e.contextType = Et, $e.defaultProps = {
    isBrowsingControlled: !1,
    browsing: !1,
    coverRef: o.a.createRef(),
    outBrowsing: function () {},
    defaultPage: 0,
    set: []
  };
  var tn = function () {
    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
      e = t.set,
      n = t.src,
      r = t.alt,
      o = t.txt;
    return Array.isArray(e) && e.length > 0 ? e : [{
      src: n,
      alt: r,
      txt: o
    }];
  };
  function en() {
    return (en = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = arguments[e];
        for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
      }
      return t;
    }).apply(this, arguments);
  }
  function nn(t) {
    return (nn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }
  function rn(t, e) {
    if (null == t) return {};
    var n,
      r,
      o = function (t, e) {
        if (null == t) return {};
        var n,
          r,
          o = {},
          i = Object.keys(t);
        for (r = 0; r < i.length; r++) n = i[r], e.indexOf(n) >= 0 || (o[n] = t[n]);
        return o;
      }(t, e);
    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(t);
      for (r = 0; r < i.length; r++) n = i[r], e.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }
  function on(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }
  function an(t) {
    return (an = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }
  function cn(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }
  function sn(t, e) {
    return (sn = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }
  var un = {
      x: 0,
      y: 0
    },
    ln = {
      x: 0,
      y: 0
    };
  "undefined" != typeof window && window.document && window.document.documentElement && document.documentElement.addEventListener("click", function (t) {
    ln = {
      x: t.clientX,
      y: t.clientY
    }, setTimeout(function () {
      return ln = {
        x: 0,
        y: 0
      };
    }, 100);
  });
  var fn = function (t) {
    function e(t) {
      var n, r, o, i, a, c;
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), r = this, o = an(e).call(this, t), n = !o || "object" !== nn(o) && "function" != typeof o ? cn(r) : o, i = cn(n), c = function () {
        var t = n.props.destroyer;
        n.setState({
          browsing: !1
        }), setTimeout(t, Ae);
      }, (a = "outBrowsing") in i ? Object.defineProperty(i, a, {
        value: c,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : i[a] = c, n.state = {
        browsing: !0
      }, un = ln, n;
    }
    var n, r, i;
    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && sn(t, e);
    }(e, t), n = e, (r = [{
      key: "render",
      value: function () {
        var t = this.props,
          e = (t.className, t.style, t.onClick, t.src),
          n = t.alt,
          r = t.txt,
          i = t.set,
          a = t.defaultPage,
          c = t.preset,
          s = t.controller,
          u = t.hotKey,
          l = t.animate,
          f = t.zIndex,
          p = t.backdrop,
          b = t.radius,
          m = t.edge,
          y = t.loop,
          d = t.directZoom,
          h = t.onBrowsing,
          g = t.onZooming,
          w = t.onSwitching,
          v = t.onRotating,
          _ = (t.browsing, rn(t, ["className", "style", "onClick", "src", "alt", "txt", "set", "defaultPage", "preset", "controller", "hotKey", "animate", "zIndex", "backdrop", "radius", "edge", "loop", "directZoom", "onBrowsing", "onZooming", "onSwitching", "onRotating", "browsing"]), this.state.browsing);
        return o.a.createElement($e, {
          browsing: _,
          coverPos: _ ? ln : un,
          outBrowsing: this.outBrowsing,
          defaultPage: a,
          set: tn({
            set: i,
            src: e,
            alt: n,
            txt: r
          }),
          preset: c,
          controller: s,
          hotKey: u,
          animate: l,
          zIndex: f,
          backdrop: p,
          radius: b,
          edge: m,
          loop: y,
          directZoom: d,
          onBrowsing: h,
          onZooming: g,
          onSwitching: w,
          onRotating: v
        });
      }
    }]) && on(n.prototype, r), i && on(n, i), e;
  }(o.a.PureComponent);
  fn.propTypes = d, fn.defaultProps = g;
  var pn = {
      REF: o.a.createRef(),
      CONTAINER: null,
      PORTAL: null
    },
    bn = function (t) {
      return pn.PORTAL = document.createElement("div"), pn.PORTAL.id = "zmagePortal", pn.CONTAINER = document.body, pn.CONTAINER.appendChild(pn.PORTAL), a.a.render(o.a.createElement(fn, en({
        ref: pn.REF,
        destroyer: function () {
          return pn.CONTAINER.removeChild(pn.PORTAL);
        }
      }, t)), pn.PORTAL), pn.REF.current.outBrowsing;
    };
  function mn(t) {
    return (mn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }
  function yn() {
    return (yn = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = arguments[e];
        for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
      }
      return t;
    }).apply(this, arguments);
  }
  function dn(t, e) {
    var n = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(t);
      e && (r = r.filter(function (e) {
        return Object.getOwnPropertyDescriptor(t, e).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function hn(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = null != arguments[e] ? arguments[e] : {};
      e % 2 ? dn(n, !0).forEach(function (e) {
        kn(t, e, n[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : dn(n).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
      });
    }
    return t;
  }
  function gn(t, e) {
    if (null == t) return {};
    var n,
      r,
      o = function (t, e) {
        if (null == t) return {};
        var n,
          r,
          o = {},
          i = Object.keys(t);
        for (r = 0; r < i.length; r++) n = i[r], e.indexOf(n) >= 0 || (o[n] = t[n]);
        return o;
      }(t, e);
    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(t);
      for (r = 0; r < i.length; r++) n = i[r], e.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }
  function wn(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }
  function vn(t) {
    return (vn = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }
  function _n(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }
  function On(t, e) {
    return (On = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }
  function kn(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }
  var zn = function (t) {
    function e(t) {
      var n, r, i;
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), r = this, i = vn(e).call(this, t), n = !i || "object" !== mn(i) && "function" != typeof i ? _n(r) : i, kn(_n(n), "inBrowsing", function () {
        n.isBrowsingControlled ? n.props.onBrowsing(!0) : n.setState({
          browsing: !0
        });
      }), kn(_n(n), "outBrowsing", function () {
        n.isBrowsingControlled ? n.props.onBrowsing(!1) : n.setState({
          browsing: !1
        });
      }), n.coverRef = o.a.createRef(), n.isBrowsingControlled = n.props.hasOwnProperty("browsing"), n.state = {
        browsing: !1
      }, n;
    }
    var n, i, a;
    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && On(t, e);
    }(e, t), n = e, (i = [{
      key: "render",
      value: function () {
        var t = this,
          e = this.props,
          n = e.className,
          i = e.style,
          a = e.onClick,
          c = e.forwardedRef,
          s = e.src,
          u = e.alt,
          l = e.txt,
          f = e.set,
          p = e.defaultPage,
          b = e.preset,
          m = e.controller,
          y = e.hotKey,
          d = e.animate,
          h = e.coverVisible,
          g = e.backdrop,
          w = e.zIndex,
          v = e.radius,
          _ = e.edge,
          O = e.loop,
          k = e.directZoom,
          z = e.onBrowsing,
          j = e.onZooming,
          x = e.onSwitching,
          P = e.onRotating,
          S = e.browsing,
          E = gn(e, ["className", "style", "onClick", "forwardedRef", "src", "alt", "txt", "set", "defaultPage", "preset", "controller", "hotKey", "animate", "coverVisible", "backdrop", "zIndex", "radius", "edge", "loop", "directZoom", "onBrowsing", "onZooming", "onSwitching", "onRotating", "browsing"]),
          T = this.state.browsing;
        return o.a.createElement(r.Fragment, null, o.a.createElement("img", yn({
          className: n,
          style: hn({
            cursor: "zoom-in"
          }, i),
          src: s,
          alt: u,
          title: u,
          onClick: function (e) {
            t.inBrowsing(), "function" == typeof a && a(e);
          },
          ref: function (e) {
            c && (c.current = e), t.coverRef && (t.coverRef.current = e);
          }
        }, E)), o.a.createElement($e, {
          isBrowsingControlled: this.isBrowsingControlled,
          browsing: this.isBrowsingControlled ? S : T,
          coverRef: this.coverRef,
          outBrowsing: this.outBrowsing,
          defaultPage: p,
          set: tn({
            set: f,
            src: s,
            alt: u,
            txt: l
          }),
          preset: b,
          controller: m,
          hotKey: y,
          animate: d,
          coverVisible: h,
          backdrop: g,
          zIndex: w,
          radius: v,
          edge: _,
          loop: O,
          directZoom: k,
          onBrowsing: z,
          onZooming: j,
          onSwitching: x,
          onRotating: P
        }));
      }
    }]) && wn(n.prototype, i), a && wn(n, a), e;
  }(o.a.PureComponent);
  zn.propTypes = d, zn.defaultProps = g;
  var jn = o.a.forwardRef(function (t, e) {
    return o.a.createElement(zn, yn({}, t, {
      forwardedRef: e
    }));
  });
  jn.browsing = bn;
  var xn = jn;
  n.d(e, "default", function () {
    return xn;
  });
}]);